import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

import Flex from 'shopper/components/Flex';

import { getFirstPathFromPathname } from 'lib/request';

import { useTopbar } from 'providers/TopbarProvider';

import TopbarBottomLeftNav from './TopbarBottomLeftNav';
import TopbarBottomRightNav from './TopbarBottomRightNav';

const StyledTopbarBottom = styled(Flex)`
  ${({ theme }) => css`
    box-shadow: ${theme.shadows.size2};
    transition: bottom ease-in 0.3s;
    will-change: bottom;
  `}
`;

const TopbarBottom = ({
  commentsCount,
  gaEventCategory,
  onLastCommentsClick,
}) => {
  const { pathname } = useRouter();
  const theme = useTheme();
  const {
    topbarDesktop: { isTopbarBottomActive },
  } = useTopbar();

  const currInitialPath = useMemo(
    () => getFirstPathFromPathname(pathname),
    [pathname]
  );

  return (
    <StyledTopbarBottom
      position="absolute"
      borderBottom="1px solid"
      bg={theme.app.topbar.background}
      bottom={isTopbarBottomActive ? '-58px' : 0}
      borderColor={theme.app.topbar.borderBg}
      full
    >
      <Flex
        alignItems="center"
        mx="auto"
        as="nav"
        px={2}
        py={2}
        width={[null, null, '100%', '64rem', '80rem']}
      >
        <TopbarBottomLeftNav
          commentsCount={commentsCount}
          currInitialPath={currInitialPath}
          gaEventCategory={gaEventCategory}
          onLastCommentsClick={onLastCommentsClick}
        />
        <TopbarBottomRightNav
          currInitialPath={currInitialPath}
          gaEventCategory={gaEventCategory}
        />
      </Flex>
    </StyledTopbarBottom>
  );
};

TopbarBottom.defaultProps = {
  commentsCount: null,
  onLastCommentsClick: () => {},
};

TopbarBottom.propTypes = {
  commentsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  onLastCommentsClick: PropTypes.func,
};

export default TopbarBottom;
